export default __webpack_public_path__ + "static/media/logomain.b48ddaa4.svg";